import { ItemName, ItemRow, SummaryQuantity } from "./styled"

export interface SupplySummaryEntry {
    key: string
    name: string
    quantity: number
}

// 「品目名 ×N」の一覧。確認画面と送信完了画面で共通。
export const SupplySummaryList = ({
    entries
}: {
    entries: SupplySummaryEntry[]
}) => (
    <>
        {entries.map(entry => (
            <ItemRow key={entry.key}>
                <ItemName selected={false}>{entry.name}</ItemName>
                <SummaryQuantity>× {entry.quantity}</SummaryQuantity>
            </ItemRow>
        ))}
    </>
)
